import React from 'react';
import { Box, Stack } from '@mui/material';
import { Customer, Item, Sale } from '../../types';
import { CustomerSelector } from './CustomerSelector';
import { ItemSelector } from './ItemSelector';
import { ShoppingCart } from './ShoppingCart';

interface SalesShoppingPanelProps {
  onSaleCompleted: (sale: Sale) => void;
  onItemAdded: (item: Item, quantity: number) => void;
  onCustomerSelected: (customer: Customer) => void;
  batchTrackingEnabled?: boolean;
}

export const SalesShoppingPanel: React.FC<SalesShoppingPanelProps> = ({
  onSaleCompleted,
  onItemAdded,
  onCustomerSelected,
  batchTrackingEnabled,
}) => (
  <Stack spacing={2.5}>
    <CustomerSelector onCustomerSelected={onCustomerSelected} />
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', xl: 'minmax(0, 1fr) 380px' }, gap: 2.5, alignItems: 'start' }}>
      <ItemSelector onItemAdded={onItemAdded} batchTrackingEnabled={batchTrackingEnabled} />
      <Box sx={{ position: { xl: 'sticky' }, top: { xl: 24 } }}><ShoppingCart onSaleCompleted={onSaleCompleted} /></Box>
    </Box>
  </Stack>
);
